import React from "react";
import Tick from "../../Assets/tick.png";

interface Props {
  title: string;
  get: Array<string>;
  price: number;
}

const Plan = (props: Props) => {
  let items = [];
  for (let i = 0; i < props.get.length; i++)
    items.push(
      <div className="item">
        <img src={Tick} alt="Tick" /> {props.get[i]}
      </div>
    );
  return (
    <div className="plan">
      <div>
        <div className="header">{props.title}</div>
        <div className="desc">What will you get?</div>
        <div className="items">{items}</div>
        <div className="cash">
          ${props.price} <div>(Limited Offer)</div>
        </div>
      </div>
      <a href="https://api.whatsapp.com/send?phone=61488877505">Start Now</a>
    </div>
  );
};

export default Plan;
